if (window.hasOwnProperty('pressbooksLti') && window.pressbooksLti.hideNavigation == '1' && window.top !== window.self) {
	document.addEventListener('DOMContentLoaded', function () {
		document.body.classList.add('no-navigation');
	});
}

